import React, {useEffect} from 'react';
import Icon from '../AppIcon';

const LegalNoticeModal = ({isOpen, onClose}) => {
  // Handle ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e?.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleBackdropClick = (e) => {
    if (e?.target === e?.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center animate-fade-in"
      style={{background: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)'}}
      onClick={handleBackdropClick}
    >
      <div className="max-h-[80vh] w-full mt-[80px] max-w-2xl mx-4 rounded-xl shadow-lg animate-scale-in overflow-hidden flex flex-col"
           style={{background: 'var(--color-card)', border: '1px solid var(--color-border)'}}>
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-lg transition-colors z-10"
          style={{background: 'transparent'}}
          onMouseEnter={(e) => e.currentTarget.style.background = 'var(--color-muted)'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          aria-label="Close modal"
        >
          <Icon name="X" size={20} color="var(--color-muted-foreground)"/>
        </button>

        {/* Header */}
        <div className="p-6 md:p-8 border-b border-border">
          <h2 className="text-2xl font-semibold" style={{color: 'var(--color-text-primary)', fontFamily: 'IBM Plex Sans', fontWeight: 600}}>
            Legal Notice | Impressum
          </h2>
        </div>

        {/* Scrollable Content */}
        <div className="p-6 md:p-8 overflow-y-auto flex-1">
          <div className="space-y-6 text-sm" style={{color: 'var(--color-text-secondary)', fontFamily: 'IBM Plex Sans'}}>
            {/* Company Information */}
            <div>
              <h3>Sleeve GmbH</h3>
              <p>Leyserstrasse 2, Top 16</p>
              <p>1140 Vienna, Austria</p>
              <a href="mailto:info@sleeve.dev">info@sleeve.dev</a>
            </div>
            {/* Registration Numbers */}
            <div>
              <h5>UID-Nummer</h5>
              <p>ATU77492679</p>
              <h5>Firmenbuchnummer</h5>
              <p>FN 566882 a</p>
              <h5>Gerichtsstand</h5>
              <p>Handelsgericht Wien</p>
              <h5>Tätigkeitsbeschreibung</h5>
              <p>Automatische Datenverarbeitung und Informationstechnik</p>
            </div>

            <div>
              <h5>Rechtsvorschriften</h5>
              <p><a href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10007517">Gewerbeordnung</a></p>
              <p><a href="https://www.ris.bka.gv.at/">https://www.ris.bka.gv.at/</a></p>
            </div>


            <div>
              <h5>Geschäftsführer</h5>
              <p>Dipl.-Ing. Emir Causevic</p>
              <p>Irmin Okic</p>
              <h5>Beteiligung</h5>
              <p>Dipl.-Ing. Emir Causevic (50%)</p>
              <p>Irmin Okic (50%)</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNoticeModal;